/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import UserService from './UserService';
import keycloak from '../keycloak';

/* default request */
axios.interceptors.response.use(
    (response) => {
        return Promise.resolve(response);
    },
    async (error) => {
        return Promise.reject(error?.response || error);
    }
);

/* default response */
axios.interceptors.request.use(
    async (config) => {
        if (!config.url.includes('public-api')) {
            // Check if the user is logged in and the token is valid and not expired if token expired, refresh the token
            if (keycloak.isTokenExpired(5)) {
                await keycloak.updateToken(30);
            }
            config.headers.Authorization = `Bearer ${UserService.getToken()}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(new Error(error));
    }
);

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    patch: axios.patch,
};
